import { render, staticRenderFns } from "./SekectShelf.vue?vue&type=template&id=7fd4c72a"
import script from "./SekectShelf.vue?vue&type=script&lang=js"
export * from "./SekectShelf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fd4c72a')) {
      api.createRecord('7fd4c72a', component.options)
    } else {
      api.reload('7fd4c72a', component.options)
    }
    module.hot.accept("./SekectShelf.vue?vue&type=template&id=7fd4c72a", function () {
      api.rerender('7fd4c72a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SekectShelf/SekectShelf.vue"
export default component.exports